
//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url + Vue.prototype.$config.resources.attachmentTemp

const attachmentTemp = {
  // create(payload: any) {},

  create(payload: any, headers: any = {}, token: boolean = true, config: any = {}) {
    let uri = url
    return Vue.prototype.$httpService
      .post(uri, payload, headers, token, config)
  },
  edit(id: string | number, payload: any) {},
  find(id: string | number) {},
  delete(id: string | number) { },
  list(params = {}) {}
}

export default attachmentTemp;
